import { render, staticRenderFns } from "./BaseSendEmailDialog.vue?vue&type=template&id=3e9d5580&"
import script from "./BaseSendEmailDialog.vue?vue&type=script&lang=js&"
export * from "./BaseSendEmailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports